<template>
  <h1 class="font-bold text-3xl text-gray-700 dark:text-dark-100 mb-2" :class="title_class">{{ title }}</h1>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: String,
    title_class: String
  }
}
</script>